export enum ShareMediaType {
  StreamingBasic = "StreamingBasic",
  StreamingTagSecure = "StreamingTagSecure",
  Download = "Download",
}
